import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';
import { parseISO } from 'date-fns';
import { Badge } from 'components/ui/badge';
import { formatDate, formatNumber } from 'helpers';

export const formatPilgrimDate = (value) => {
  if (!value) return null;
  const parsed = /^\d{4}-\d{2}-\d{2}$/.test(value) ? parseISO(value) : value;
  try {
    return formatDate(parsed);
  } catch (_error) {
    return null;
  }
};

const PilgrimDepositItem = ({ deposit }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const initiated = formatPilgrimDate(deposit.created);
  const validated = formatPilgrimDate(deposit.payment_date);

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white text-xs">
      <button
        type="button"
        className="flex min-h-16 w-full items-center gap-3 p-3 text-left hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
        onClick={() => setIsExpanded((open) => !open)}
        aria-expanded={isExpanded}
      >
        <span className="min-w-0 flex-1">
          <strong className="block text-sm font-semibold tabular-nums text-gray-900">
            {formatNumber(Number(deposit.amount) || 0)} F CFA
          </strong>
          <span className="mt-1 block text-xs text-gray-500">{initiated || '-'}</span>
        </span>
        <Badge variant={deposit.is_invoice_paid ? 'success' : 'pending'} className="shrink-0">
          {deposit.is_invoice_paid ? 'Payé' : 'En attente'}
        </Badge>
        <ChevronDown
          className={`size-4 shrink-0 text-gray-500 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
        />
      </button>

      {isExpanded && (
        <dl className="grid grid-cols-1 gap-3 border-t bg-gray-50/70 px-3 py-3 sm:grid-cols-2">
          <div>
            <dt className="text-gray-500">Date d’initiation</dt>
            <dd className="mt-1 font-medium text-gray-900">{initiated || '-'}</dd>
          </div>
          <div>
            <dt className="text-gray-500">Date de validation</dt>
            <dd className="mt-1 font-medium text-gray-900">{validated || '-'}</dd>
          </div>
          <div className="sm:col-span-2">
            <dt className="text-gray-500">Référence facture</dt>
            <dd className="mt-1 break-all font-mono font-medium text-gray-900">{deposit.invoice_code || '-'}</dd>
          </div>
          <div className="sm:col-span-2">
            <dt className="text-gray-500">Statut</dt>
            <dd className="mt-1 font-medium text-gray-900">{deposit.is_invoice_paid ? 'Payé' : 'En attente'}</dd>
          </div>
        </dl>
      )}
    </div>
  );
};

PilgrimDepositItem.propTypes = {
  deposit: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    created: PropTypes.string,
    payment_date: PropTypes.string,
    invoice_code: PropTypes.string,
    is_invoice_paid: PropTypes.bool,
  }).isRequired,
};

export default PilgrimDepositItem;
